import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'home',
    meta: { authRequired: false,},
    component: () => import('./views/account/home'),
  },
  {
    path: '/shops',
    name: 'shops',
    component: () => import('./views/ecommerce/shops'),
    meta: { authRequired: false,},
  },
  {
    path: '/shop',
    name: 'shop',
    component: () => import('./views/ecommerce/shop'),
    meta: { authRequired: false,},
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('./views/ecommerce/products'),
    meta: { authRequired: false,},
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('./views/ecommerce/product'),
    meta: { authRequired: false,},
  },
  {
    path: '/category',
    name: 'category',
    component: () => import('./views/ecommerce/category'),
    meta: { authRequired: false,},
  }
  ,{
    path: '/order',
    name: 'order',
    component: () => import('./views/ecommerce/order'),
    meta: { authRequired: false,},
  }
  ,{
    path: '/print',
    name: 'print',
    component: () => import('./views/ecommerce/print'),
    meta: { authRequired: false,},
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('./views/account/contact'),
    meta: { authRequired: false,},
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: () => import('./views/account/aboutus'),
    meta: { authRequired: false,},
  },
  {
    path: '/tc',
    name: 'tc',
    component: () => import('./views/account/tc'),
    meta: { authRequired: false,},
  },
  {
    path: '/cp',
    name: 'cp',
    component: () => import('./views/account/cp'),
    meta: { authRequired: false,},
  },
  {
    path: '/pp',
    name: 'pp',
    component: () => import('./views/account/pp'),
    meta: { authRequired: false,},
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('./views/account/faq'),
    meta: { authRequired: false,},
  },
  
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.removeItem('user')
        localStorage.removeItem('token');
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/')
        )
        next(authRequiredOnPreviousRoute ? { name: 'dashboard' } : { ...routeFrom })
      },
    },
  },

  
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/dashboard')
  },
  {
    path: '/cart',
    name: 'cart',
    meta: { authRequired: true },
    component: () => import('./views/ecommerce/cart')
  },
  {
    path: '/checkout',
    name: 'checkout',
    meta: { authRequired: true },
    component: () => import('./views/ecommerce/checkout')
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/pages/404',
    name: 'Error-404',
    meta: { authRequired: true },
    component: () => import('./views/utility/404')
  },
  {
    path: '/pages/500',
    name: 'Error-500',
    meta: { authRequired: true },
    component: () => import('./views/utility/500')
  },
]
